module.exports = __webpack_public_path__ + "img/mcqueen.e5e04db1.jpg";